import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { RouteLocation } from 'vue-router'
import { MenuLeaf, Navigation, NavigationItems } from '@sennder/shell-utilities'

import { i18n } from '@/services/i18n'
import { navigation } from '@/config/navigation'
import { getStateData } from '@/store/getters'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavigationItems',
  setup(__props) {

const dataToWatch = [
  () => getStateData().featureFlags,
  () => getStateData().profile,
  () => getStateData().language,
]

const translateItem = (item: Navigation<string>) =>
  i18n.global.t(item.translationKey)

const isNavItemSelected = (route: RouteLocation, item: MenuLeaf<string>) => {
  if (route.path === '/marketplace/tenders') {
    return route.path === item.route
  }
  return route.path.startsWith(item.route)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NavigationItems), {
    navigation: _unref(navigation),
    "data-to-watch": dataToWatch,
    "translate-item": translateItem,
    "is-item-selected": isNavItemSelected
  }, null, 8 /* PROPS */, ["navigation"]))
}
}

})